import React from 'react';
import { Container, Navbar, Nav, Button, Badge } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../assets/css/DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async() => {
    await logout();
    console.log('✅ Sesión cerrada, redirigiendo...');
    navigate('/login', { replace: true }); 
  };

  return (
    <div className="dashboard-layout">
      <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
        <Container>
          <Navbar.Brand as={Link} to="/dashboard">
            <strong>LinksEasy</strong> Dashboard

              {user?.plan_type === 'premium' ? (
              <Badge bg="white" text="dark" className="ms-2">⭐ PREMIUM</Badge>
            ) : (
              <Badge bg="secondary" className="ms-2">GRATUITO</Badge>
            )}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {user && (
                <div className="d-flex align-items-center">
                  <span className="text-light me-3">
                    <img 
                      src={user.avatar_url} 
                      alt={user.name}
                      className="rounded-circle me-2"
                      width="32"
                      height="32"
                    />
                    {user.name}
                  </span>
                  <Button variant="outline-light" size="sm" onClick={handleLogout}>
                    Cerrar sesión
                  </Button>
                </div>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container className="dashboard-content">
        {children}
      </Container>
    </div>
  );
};

export default DashboardLayout;